module.exports = __webpack_public_path__ + "static/media/tarik64.68c7ecb4.png";